import styled from 'styled-components';

const Button = styled.button`
    color: ${props => props.theme.button[props.variant || 'secondary'].text};
    position: relative;
    background-color: ${props => props.theme.button[props.variant || 'secondary'].background};
    border-radius: ${props => props.theme.metrics.radius};
    border: 1px solid ${props => props.theme.button[props.variant || 'secondary'].border};
    font-family: ${props => props.theme.font.face.baseFace};
    font-size: ${props => props.theme.font.size.zeta};
    line-height: 1.5;
    font-weight: 500;
    cursor: pointer;
    padding: 9px 19px;
    padding-bottom: 8px;
    padding-top: 10px;
    z-index: 1;
    -webkit-font-smoothing: antialiased;

    &::before {
        border-radius: ${props => props.theme.metrics.radius};
        border: inherit;
        border-width: 2px;
        content: '';
        display: block;
        position: absolute;
        top: 3px;
        right: 3px;
        bottom: 3px;
        left: 3px;
    }
    &:focus,
    &:hover {
        background-color: ${props => props.theme.button[props.variant || 'secondary'].hover};
    }

    &:focus {
        outline: 0;
    }

    &:active {
        background-color: ${props => props.theme.button[props.variant || 'secondary'].active};
    }

    &:disabled {
        background-color: ${props => props.theme.colors.xlightgrey};
        color: ${props => props.theme.colors.grey};
        border-color: ${props => props.theme.colors.lightgrey};
    }

    &.block {
        width: 100%;
    }
`;

export default Button;
